var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraph(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 81 81",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("line", {
    strokeWidth: "5.1px",
    x1: 4.675,
    x2: 77.675,
    y1: 77.95,
    y2: 77.95
  }), /*#__PURE__*/React.createElement("line", {
    strokeWidth: "5.2px",
    x1: 3.375,
    x2: 3.375,
    y1: 77.95,
    y2: 3.05
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: "5px",
    transform: "translate(-9.525,-9.55)",
    points: "21 69.5 42.3 46.7 57.8 58.5 79.4 32.8"
  }), /*#__PURE__*/React.createElement("polyline", {
    strokeWidth: "5px",
    transform: "translate(-9.525,-9.55)",
    points: "70.5 31 81.7 30.5 82.1 41.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraph);
export default __webpack_public_path__ + "static/media/graph.0cb0fb22.svg";
export { ForwardRef as ReactComponent };